import { useState, useEffect, useRef } from 'react';
import user from '../../../helpers/user';
import { InputOTP } from './InputOTP';
import { InputPIN } from './InputPIN';
import InputPassword from './InputPassword';
import { PurchaseSuccess } from './PurchaseSuccess';
import useEscapeKey from '../../../hooks/useEscapeKey';
import { resetQitafProperty } from '../../../services/serviceWrapper/qitafServiceWrapper';
import { Modal } from '../../ui/Modal';

export const TVODOverlayComponent = {
    PIN: InputPIN,
    OTP: InputOTP,
    PASSWORD: InputPassword,
    SUCCESS: PurchaseSuccess,
};

export const TVODOverlayType = {
    PIN: 'PIN',
    OTP: 'OTP',
    PASSWORD: 'PASSWORD',
    SUCCESS: 'SUCCESS',
};

interface TVODOverlayNoPortalProps {
    isOpen: boolean;
    onClose: () => void;
    isPPV?: boolean;
    eventData?: any;
    tvodInfo: any;
    content?: any;
    onPurchase?: (e: any) => void;
}

const TVODOverlayNoPortal = ({
    isOpen,
    onClose,
    isPPV,
    eventData,
    tvodInfo,
    content,
    onPurchase,
}: TVODOverlayNoPortalProps) => {
    const overlayRef = useRef(null);

    useEscapeKey(onOverlayClose);
    const userInfo = user.getUserInfo();
    const operator = userInfo?.operator;
    let type;
    if (isPPV) {
        type = user.getPPVPurchaseOption(operator);
    } else {
        type = user.getTVODPurchaseOption(operator);
    }

    const [currentComponentType, setCurrentComponentType] = useState(type);
    const [qitafUpdatedPrice, setQitafUpdatedPrice] = useState(tvodInfo?.priceWithVat);
    const [qitafApplied, setQitafApplied] = useState(false);

    useEffect(() => {
        if (isOpen && tvodInfo?.priceWithVat != null) {
            setQitafUpdatedPrice(tvodInfo.priceWithVat);
            setQitafApplied(false);
        }
    }, [isOpen, tvodInfo?.priceWithVat]);

    function onOverlayClose() {
        setCurrentComponentType(type);
        resetQitafProperty('upadtedPrice');
        resetQitafProperty('qitafRefId');
        setQitafApplied(false);
        onClose();
    }

    const Component = TVODOverlayComponent[currentComponentType];

    if (!type || !isOpen || !Component) return null;

    const qitafProps = {
        qitafUpdatedPrice,
        qitafApplied,
        setQitafUpdatedPrice,
        setQitafApplied,
    };

    return (
        <>
            <Modal
                useFlexLayout={false}
                onOpenChange={onOverlayClose}
                open={isOpen}
                widthSet="medium"
                // ref={overlayRef}
            >
                <Component
                    {...{ isOpen, onClose, isPPV, eventData, tvodInfo, content, handlePurchase: onPurchase }}
                    {...qitafProps}
                    setCurrentComponentType={setCurrentComponentType}
                    onOverlayClose={onOverlayClose}
                />
            </Modal>
        </>
    );
};

export default TVODOverlayNoPortal;
